import React from 'react'
import { useForm, Link } from '@inertiajs/react'
import { TextField, Button, Typography, Stack } from '@mui/material'
import AuthLayout from '@/components/layouts/AuthLayout'
import { SPACING } from '@/theme'

export default function ForgotPassword() {
  const { data, setData, post, processing, errors } = useForm({
    email: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/users/password')
  }

  return (
    <AuthLayout title="Reset your password">
      <Stack component="form" onSubmit={handleSubmit} spacing={SPACING.gap.md}>
        <Typography variant="body2" color="text.secondary">
          Enter your email address and we'll send you a link to reset your password.
        </Typography>
        <TextField
          label="Email address"
          type="email"
          fullWidth
          value={data.email}
          onChange={(e) => setData('email', e.target.value)}
          error={!!errors.email}
          helperText={errors.email}
          autoFocus
          autoComplete="email"
        />
        <Button type="submit" variant="contained" fullWidth size="large" disabled={processing}>
          Send reset instructions
        </Button>
        <Typography variant="body2" align="center">
          Remember your password? <Link href="/users/sign_in">Sign in</Link>
        </Typography>
      </Stack>
    </AuthLayout>
  )
}
